import React, { FC, useState, useEffect } from "react";
import styled from "styled-components";
import { ProfileBeaconControl } from "./ProfileBeaconComponents";
// import {ProfileBeaconDropdown} from "../Shared/ProfileBeaconComponents";

interface Props {
    name?: string;
    label?: string;
    value?: string;
    id?: string;
    options?: any;
    hideDropdownLabel?: boolean;
    onInput?: (event: any) => void;
    onClick?: (event: any) => void;
    onBlur?: (event: any) => void;
    className?:string;
}

const StyledDropdown = styled(ProfileBeaconControl)`
select{
    width: ${({ name }) =>
    name === "paycheckFrequency"
      ? "156px"
      : name === "monthlyPerformance" || name === "dailyPrices"
      ? "400px"
      : name === "investmentExperienceLevelType"
      ? "205px"
      : "217px"};
  
  @media(max-width: 640px){
    width: ${({name}) => (name === "monthlyPerformance" || name === "dailyPrices") ? "100%" : name === "paycheckFrequency" ? "140px" : ""};
  };
     
  @media screen and (max-width: 480px){
  max-width: ${({name}) => name === "investmentExperienceLevelType" && "120px"};
  };

  --beacon-form-label-font-size: 0px;
  display: ${({hideDropdownLabel}) => hideDropdownLabel && "flex"};}
`;
function useScreenWidth() {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return width;
}
const Dropdown: FC<Props> = ({
                                 name,
                                 id,
                                 value,
                                 label,
                                 options,
                                 hideDropdownLabel,
                                 onInput,
                                 onClick,
                                 onBlur,
                                 className
                                 
                                }) => {
                                    const screenWidth = useScreenWidth();
            const dropdownWidth =
        (name === "investmentExperienceLevelType" || name === "genderType")
            ? screenWidth < 768
                ? "171px"
                : screenWidth < 991
                ? "175px"
                : "216px"
            : name === "paycheckFrequency"
            ? "156px"
            : undefined;

    return (
        <StyledDropdown>
        
             <select hideDropdownLabel={hideDropdownLabel} id={id} 
              style={{ width: dropdownWidth }} className={className} name={name} onBlur={onBlur} onInput={onInput} onClick={onClick} value={value}
             >
             
                
                {options && options.map( (item : any) => {
                    return (
                            <>
                                <option value={item.value}>{item.name}</option>
                            </>
                    )
                })
            }
            {/* width: ${({name}) => name === "paycheckFrequency" ? "156px": (name === "monthlyPerformance" || name === "dailyPrices") ? "400px": "217px"}; */}
        </select>

        </StyledDropdown>  
     
    )
}
export default Dropdown